import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=877a078c"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports